import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Drawer, Button, Space } from "antd";
import Pagination from "@mui/material/Pagination";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faCloudDownload } from '@fortawesome/free-solid-svg-icons';

import TobNavBar from "../../DashBaord/Top_navbar";
import ShowData from "../../../components/ShowData";
import { Link } from "react-router-dom";

import moment from "moment";
import SkeltonList from "../../../components/SkeltonEffect/list";
import { list } from "../../../controllers/V1/walletStatement/walletStatementController";
import { getPage } from "../../../controllers/common";
import { formatProjectDate } from "../../../controllers/common";
import SelectUsers from "../../../components/SelectUsers";
import Export from "./Export";
import { list as generalData } from "../../../controllers/V1/cms/generalDataController";
function VendorList(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

VendorList.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {

  const [isFilterShow, setFilterShow] = useState(false);
  const handleFiterDrawer = () => setFilterShow(!isFilterShow);

  const [isExportShow, setExportShow] = useState(false);
  const handleExportOrder = () => setExportShow(!isExportShow);

  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  /************************************************************************************* */
  const [isLoading, setIsLoading] =useState(false);
  const targetRef = useRef(null);
  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [ALLLISTDATA, setListData] = useState([]);
  const [TOTALPAGES, setTotalPages] = useState(1);
  const [LIMIT, setLimit] = useState(10);
  const [SKIP, setSkip] = useState(0);
  const [filter, setFilter] = useState({
    from: "",
    to: new Date(),
    filter_by: "",
    search: "",
  }); //End
  const [fromDate, setFromDate] = useState(`${moment().startOf('day').format('YYYY-MM-DD HH:mm:ss')}`);
  const [toDate, setToDate] = useState(`${moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')}`);
  const [showRequest, setShowRequest] = useState("");

  /*********************************************************
   *  This function is use to fetch vendor list
   *********************************************************/
  const getList = async () => {
    try {
      setIsLoading(true);
      setListData([]);
      const today = new Date();
      let from_date = filter?.from;
      let to_date = filter?.to;

      if(from_date && !to_date){
        to_date = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;
      }
      const options = {
        type: "",
        condition: {
          ...(filter?.filter_by === 'order_no' && {
            $or : [
                {order_id : filter?.search},
                {promocodeOrderNo : filter?.search},
                {product_order_no : filter?.search},
                {campaignOrderNo : filter?.search},
            ] 
        }),
          ...(filter?.filter_by === 'record_type' && {record_type : filter?.search }),

          ...(filter?.filter_by === 'title'?{title : { $regex: filter?.search, $options: "i" } }:null),
          ...(filter?.filter_by === 'name'?{name : { $regex: filter?.search, $options: "i" } }:null),
          ...(filter?.filter_by === 'prize'?{prize : { $regex: filter?.search, $options: "i" } }:null),
          
          ...(filter?.filter_by === 'points'?{mobile : parseInt(filter?.search) }:null),
          ...(filter?.filter_by === 'availableArabianPoints'?{availableArabianPoints : parseInt(filter?.search) }:null),
          ...(filter?.filter_by === 'end_balance'?{end_balance : parseInt(filter?.search) }:null),

          ...(filter?.from?{createdAt : {$gte : filter.from, $lte : filter.to} }:null),
          ...(showRequest ? { record_type: showRequest } : null),
          $or : [
            {credit_user : userData?.bind_person_id},
            {debit_user : userData?.bind_person_id},
          ]
        },
        select: {},
        sort: { _id: -1 },
        skip: SKIP ? SKIP : 0,
        limit: LIMIT ? LIMIT : 10,
      };
      const listData = await list(options);
      if (listData.status === true) {
        if (listData.result.length > 0) {
          setListData(listData?.result);
          setTotalPages(getPage(listData?.count, LIMIT))
        } else {
          setListData([]);
          setTotalPages(getPage(1))
        }
      } else {
        setListData([]);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }; //End

  /*********************************************************
   *  This function is for handle page change
   *********************************************************/
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
    setSkip((newPage - 1) * LIMIT);
    targetRef.current.scrollIntoView({
      behavior: "smooth",
    });
  };

  /*********************************************************
   *  This function is ued for handle filter input change
   *********************************************************/
  const handleFilterReset = () => {
    try {
      setFilter('');
      inputRef1.current.value = '';
      inputRef2.current.value = '';
      inputRef3.current.value = '';
      inputRef4.current.value = '';
    } catch (error) {
      
    }
  }

  const handleFilterApply = (e) => {
    try {
      e.preventDefault();
      const form = new FormData(e.target);
      setFilter((pre)=>({
        ...pre,
        'filter_by' : form.get('filter_by') || '',
        'search'    : form.get('search') || '',
        // 'to'        : form.get('to_date') || '',
        // 'from'      : form.get('from_date') || '',

      }))
      
      handleFiterDrawer();
      setSkip(0);
    } catch (error) {
      
    }
  }
  const [userData, setUserData] = useState({});

  /*********************************************************
   *  This function will load when page load and with dependency update
   *********************************************************/
  useEffect(() => {
    if(userData && userData.bind_person_id){
      getList();
    }
    targetRef.current.scrollIntoView({
      behavior:'smooth',
    });
    document.title = "Orbit Kuwait || Wallet's Statement";
  }, [currentPage, showRequest, filter, userData?.bind_person_id, LIMIT]);


  const handleFilterChange = (e) =>{
    const {name, value} = e.target;
    if(name === 'from_date'){
      setFromDate(`${moment(value).format('YYYY-MM-DD HH:mm:ss')}`)
    } else if(name === 'to_date'){
      setToDate(`${moment(value).format('YYYY-MM-DD HH:mm:ss')}`)
    } else {
      setFilter((pre)=>({
        ...pre,
        [name] : value
      }))
    }
  }

  const getGeneralData = async () => {
    try {
      const res = await generalData();
      if(res?.status === true){
        const { draw_start_time, draw_end_time } = res.result;
        if(draw_start_time) setFromDate(`${moment().format('YYYY-MM-DD')} ${draw_start_time}`)
        if(draw_end_time) setToDate(`${moment().format('YYYY-MM-DD')} ${draw_end_time}`)
      }  
    } catch (error) {
      
    }
  }
  useEffect(()=>{
    getGeneralData();
  },[])
  return (
    <>
      <div className="container-fluid" ref={targetRef}>
        <TobNavBar title={"Wallet's Statement"}></TobNavBar>
        <div className="inventory_tabs_main_div">
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <div className="inventory_all_tabs">
                <div className="all_tabs_value">
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    className="item_tabs_main_container"
                  >
                    <Tab
                      label="All"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() => setShowRequest("")}
                    />
                    <Tab
                      label="Debit"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() => setShowRequest("Debit")}
                    />
                    <Tab
                      label="Credit"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() => setShowRequest("Credit")}
                    />
                  </Tabs>
                </div>

                <div className="fa_filter_rating_review filter_img_and_add_btn_main">
                  <div>
                    <ShowData setLimit={setLimit} limit={LIMIT} />
                  </div>
                  <div className="inventory_filter_div" onClick={handleFiterDrawer}>
                    <FontAwesomeIcon icon={faFilter} />
                    <Link
                      to={false}
                      className="filter_btn_invontry_rating_review"
                    >
                      Filter
                    </Link>
                  </div>

                  <div className="inventory_filter_div" onClick={handleExportOrder}>
                    <FontAwesomeIcon icon={faCloudDownload} />
                    <Link
                      to={false}
                      className="filter_btn_invontry_rating_review"
                    >
                      Export
                    </Link>
                  </div>

                </div>
              </div>
            </Box>
            <br/>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <div className="inventory_all_tabs">
                  <SelectUsers setAddEditData={setUserData}/>
                </div>
            </Box>            
            <VendorList 
              >
              <div>
                <div id="content-wrapper" className="d-flex flex-column">
                  <div className="card shadow mb-4">
                    <div className="card-body pt-0">
                      <div className="table-responsive">
                        <table
                          className="table table-bordered"
                          id="dataTable"
                          width="100%"
                          cellspacing="0"
                        >
                          <thead>
                            <tr>
                              <th>Sl. No.</th>
                              <th>Narration</th>
                              <th>Details</th>
                              <th>Points</th>
                              <th>Avl. Balance</th>
                              <th>End Balance</th>
                              <th>Created Date & Time</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {ALLLISTDATA?.length > 0 ? (
                              ALLLISTDATA.map((items, index) => (
                                <>
                                  <tr key={index} >
                                    <td>{SKIP + index + 1}</td>
                                    <td>{items?.narration}</td>
                                    <td>
                                        {(
                                            items?.narration === 'Lotto Winner Redeem' ||
                                            items?.narration === 'Campaign Commission' ||
                                            items?.narration === 'Campaign commission' ||
                                            items?.narration === 'Campaign Purchase' ||
                                            items?.narration === 'Campaign Purchase Cancel' ||
                                            items?.narration === 'Campaign Commission Reverse' 

                                        ) && ( <>
                                            <p>Campaign Title : {items?.campaign_title}</p>
                                            <p>Order No. : {items?.campaignOrderNo}</p> 
                                        </>)}

                                        {(items?.narration === 'Product Order' || items?.narration === 'Product Cancel') && ( <>
                                            {/* <p>Code. : {items?.promo_code}</p>  */}
                                            <p>Order No. : {items?.product_order_no}</p> 
                                        </>)}

                                        {(
                                            items?.narration === 'Voucher Commission' ||
                                            items?.narration === 'Voucher Purchase' ||
                                            items?.narration === 'Voucher Commission Reverse' ||
                                            items?.narration === 'Voucher Order Cancel'
                                        ) && ( <>
                                            <p>Code. : {items?.promo_code}</p> 
                                            <p>Order No. : {items?.promocodeOrderNo}</p> 
                                        </>)}

                                        {(
                                            items?.narration === 'Recharge'
                                        ) && ( <>
                                            <p>Mobile : {items?.credit_user?.users_mobile}</p> 
                                        </>)}
                                    </td>
                                    <td>{Math.floor(items?.points * 100) / 100}</td>
                                    <td>{Math.floor(items?.availableArabianPoints * 100) / 100}</td>
                                    <td>{Math.floor(items?.end_balance * 100) / 100}</td>
                                    <td>{moment(formatProjectDate(items?.createdAt)).format('DD-MM-YYYY hh:mm A')}</td>
                                    <td>
                                        {items?.record_type === 'Debit' ?(
                                            <Button type="primary" style={{ backgroundColor: '#ae1151', color: 'white' }}> {items?.record_type} </Button>
                                        ):(
                                            <Button type="primary" style={{ backgroundColor: 'rgb(17 174 87)', color: 'white' }}> {items?.record_type} </Button>
                                        )}
                                    </td>
                                  </tr>
                                </>
                              ))
                            ) : isLoading ? <SkeltonList row={5} col={9} /> : <tr> 
                                <td colspan="9" className="img-center" >No data found !</td> 
                            </tr>}
                          </tbody>
                        </table>
                        <div className="table_pagination_sales_order">
                          <Pagination
                            count={TOTALPAGES}
                            onChange={handlePageChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </VendorList>
          </Box>
        </div>
      </div>
      
      {/* Filter */}
      <Drawer
        title="Filter"
        placement={`right`}
        width={500}
        onClose={handleFiterDrawer}
        open={isFilterShow}
        extra={
          <Space>
            <Button onClick={handleFiterDrawer}>Cancel</Button>
            <Button type="primary" onClick={handleFilterReset}  style={{ backgroundColor: 'red', color: 'white' }}>
              Reset
            </Button>
          </Space>
        }
      >
        <div className="responsive">
          <div className="row">
            <form id='filter_form' onSubmit={handleFilterApply}>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  Search Field :
                </label>
                <select name="filter_by" className="form-control store_input_field" id="filter_by" ref={inputRef1}>
                  <option value='' selected disabled>Select search field</option>
                  <option value='load_balance_id' selected={filter?.filter_by ==='load_balance_id'?true:false}>Seq. ID</option>
                  <option value='order_no' selected={filter?.filter_by ==='order_no'?true:false}>Order number</option>
                  <option value='narration' selected={filter?.filter_by ==='narration'?true:false}>Narration</option>
                  <option value='points' selected={filter?.filter_by ==='points'?true:false}>Points</option>
                  <option value='availableArabianPoints' selected={filter?.filter_by ==='availableArabianPoints'?true:false}>Avl. Points</option>
                  <option value='end_balance' selected={filter?.filter_by ==='end_balance'?true:false}>End Balance</option>
                  <option value='record_type' selected={filter?.filter_by ==='record_type'?true:false}>Status</option>
                </select>
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  Search Text :
                </label>
                <input
                  title="Enter search text."
                  placeholder="Enter search text."
                  type="text"
                  name="search"
                  className="form-control store_input_field"
                  id="search"  
                  ref={inputRef2}
                />
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  From :
                </label>
                <input
                  title="Enter search text."
                  type="datetime-local"
                  name="from_date"
                  value={fromDate}
                  onChange={handleFilterChange}
                  className="form-control store_input_field"
                  id="from_date"      
                  ref={inputRef3}
                />
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  To :
                </label>
                <input
                  title="Enter search text."
                  type="datetime-local"
                  name="to_date"
                  value={toDate}
                  onChange={handleFilterChange}
                  className="form-control store_input_field"
                  id="to_date"   
                  ref={inputRef4}
                />
              </div>
              <br/>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <button
                  title="Enter search text."
                  type="submit"
                  className="form-control btn btn-black"    
                  style={{ backgroundColor: "black", color: "white" }}           
                >Apply</button>
              </div>
            </form>
          </div>
        </div>
      </Drawer>
      <Export popUpOpen={isExportShow} togglePopUp={handleExportOrder} userData={userData} />
    </>
  );
}
